import { MARK_COMMENT } from "../constants";

export const getCommentKeyId = (key: string): string=>{
  return key.replace(`${MARK_COMMENT}_`, "");
};